export default __webpack_public_path__ + "static/media/icon-mexico.c5d9bd7a.svg";